let Search = document.querySelector(".Search"),
    SearchForm = Search.querySelector(".form"),
    SearchFormInput = SearchForm.querySelector("input"),
    SearchSelect = Search.querySelector(".Search__modalInnerBlockSelect select"),
    SearchInnerSps = document.querySelectorAll(".Search__innersp"),
    SearchBtn = Search.querySelector(".Search__modalInnerBlock input"),
    ads = document.querySelectorAll(".Search__innerBlockAdInner"),
    adbgs = document.querySelectorAll(".Search__bg")

SearchFormInput.addEventListener("focus", () => {
    toggle(SearchFormInput, true)
})

SearchInnerSps.forEach((sp) => {
    sp.addEventListener("click", () => {
        toggle(sp)
    })
})

ads.forEach((ad) => {
    ad.addEventListener("click", () => {
        toggle(ad)
    })
})

adbgs.forEach((bg) => {
    bg.addEventListener("click", () => {
        toggle(bg)
    })
})

const toggle = (elm, bool = false) => {
    let target = elm.closest(".Search")
    if (!bool) {
        target.classList.toggle("is-on")
    } else {
        target.classList.add("is-on")
    }

    if (target.classList.contains("is-on")) {
        document.body.style.overflowY = "hidden"
        document.documentElement.style.overflowY = "hidden"
    } else {
        document.body.style.overflowY = "auto"
        document.documentElement.style.overflowY = "auto"
    }
}